import { render } from "./UserAddGroupModal.vue?vue&type=template&id=6123dc63&scoped=true&ts=true"
import script from "./UserAddGroupModal.vue?vue&type=script&lang=ts"
export * from "./UserAddGroupModal.vue?vue&type=script&lang=ts"

import "./UserAddGroupModal.vue?vue&type=style&index=0&id=6123dc63&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6123dc63"]])

export default __exports__